import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const WalletBalance = ({ walletData }) => {
  const navigate = useNavigate();
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    })?.format(amount);
  };

  const subsidyPercentage = (walletData?.subsidyUsed || 75);

  return (
    <div className="bg-gradient-to-br from-emerald-500 via-green-500 to-teal-600 rounded-xl p-6 text-white shadow-xl">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="Wallet" size={20} color="white" />
          </div>
          <div>
            <h3 className="font-heading font-bold text-lg">Billetera Universitaria</h3>
            <p className="text-white/90 text-xs">Universidad Panamericana</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-white/90 text-xs">Disponible</p>
          <p className="font-data font-bold text-2xl">{formatCurrency(walletData?.balance || 485.50)}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-4">
        <div className="bg-white/15 backdrop-blur-sm rounded-lg p-3 border border-white/20">
          <div className="flex items-center space-x-1 mb-1">
            <Icon name="Gift" size={14} color="white" />
            <span className="text-xs font-medium">Subsidio Mensual</span>
          </div>
          <p className="font-data font-bold text-lg">{formatCurrency(walletData?.monthlySubsidy || 400)}</p>
          <p className="text-white/80 text-xs">Próximo: {walletData?.nextSubsidyDate || "15 Nov"}</p>
        </div>

        <div className="bg-white/15 backdrop-blur-sm rounded-lg p-3 border border-white/20">
          <div className="flex items-center space-x-1 mb-1">
            <Icon name="ShoppingBag" size={14} color="white" />
            <span className="text-xs font-medium">{walletData?.bagsThisMonth || 8} Bolsas este mes</span>
          </div>
          <p className="font-data font-bold text-lg">{formatCurrency(walletData?.savedThisMonth || 320)} Ahorrado este mes</p>
        </div>
      </div>
      {/* Progress indicator with better contrast */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm font-medium text-white">{subsidyPercentage}%</span>
          <span className="text-sm font-medium text-white">Subsidio mensual usado</span>
        </div>
        <div className="w-full bg-white/30 rounded-full h-2">
          <div 
            className="bg-white h-2 rounded-full transition-all duration-300" 
            style={{ width: `${subsidyPercentage}%` }}
          ></div>
        </div>
      </div>
      <button 
        onClick={() => navigate('/university-wallet')}
        className="w-full bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200 text-sm"
      >
        Ver billetera
      </button>
      {/* Special offers section */}
      {walletData?.specialOffers && (
        <div className="mt-4 space-y-2">
          <p className="text-white/90 text-sm font-medium">Ofertas Especiales</p>
          {walletData?.specialOffers?.slice(0, 2)?.map((offer, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-2 border border-white/20">
              <p className="text-white text-xs font-medium">{offer?.title}</p>
              <p className="text-white/80 text-xs">{offer?.discount}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WalletBalance;